import { AbstractControl } from '@angular/forms';

/**
 * Trims leading and trailing whitespace from a control's string value.
 *
 * - Looks up a child control by `controlPath` on the provided `root` control.
 * - If found, converts `null`/`undefined` to an empty string, applies `.trim()`,
 *   and writes the trimmed value back with `{ emitEvent: false }`.
 * - Marks the control as touched, but does not call `updateValueAndValidity`;
 *   callers should invoke it on the parent form when appropriate.
 *
 * Returns the trimmed string value (or an empty string if the control is missing).
 */
export function trimControlValue(
  root: AbstractControl,
  controlPath: string | (string | number)[]
): string {
  const control = root.get(controlPath);
  if (!control) {
    return '';
  }

  const rawValue = control.value ?? '';
  const trimmedValue = typeof rawValue === 'string' ? rawValue.trim() : String(rawValue).trim();

  if (trimmedValue !== rawValue) {
    control.setValue(trimmedValue, { emitEvent: false });
  }

  control.markAsTouched();

  return trimmedValue;
}


